{
  "title": {
    "tag": "DEC Explorer",
    "title": "Quantifica i tuoi risparmi adottando la nostra soluzione"
  },
  "intro-text": {
    "1": "Seleziona un impianto fotovoltaico:",
    "2": "Fornisci i dati:",
    "3": "I tuoi risultati:"
  },
  "plant-card": {
    "buttons": {
      "select-plant": "Seleziona"
    }
  },
  "form": {
    "fields": {
      "renewableEnergy": {
        "label": "Volume contrattualizzato <infoLink> Indica la quantità di consumo energetico annuo che desideri rendere green producendo Garanzie d'Origine con la soluzione di DEC Energy. </infoLink>",
        "error": "Inserisci un valore valido per il volume contrattualizzato"
      },
      "goPrice": {
        "label": "Prezzo delle GO <infoLink> Utilizza il cursore qui sotto o scrivi nel campo per indicare il prezzo approssimativo che stai pagando per l'approvvigionamento delle Garanzie d’Origine. NOTA: puoi anche inserire un valore superiore al massimo indicato dal cursore. </infoLink>",
        "error": "Inserisci un valore valido per il prezzo delle GO"
      },
      "grayPrice": {
        "label": "Prezzo energia (materia prima)<infoLink> Indica il prezzo che stai pagando per l’approvvigionamento di energia (considerando solo il costo della materia prima). </infoLink>",
        "error": "Inserisci un valore valido per il prezzo dell'energia"
      },
      "optimistic": {
        "label": "Scenario 1",
        "error": "Inserisci prezzi validi per lo Scenario 1"
      },
      "normal": {
        "label": "Scenario 2",
        "error": "Inserisci prezzi validi per lo Scenario 2"
      },
      "pessimistic": {
        "label": "Scenario 3",
        "error": "Inserisci prezzi validi per lo Scenario 3"
      }
    },
    "back": "Torna agli impianti",
    "submit": "Calcola i risultati",
    "mode": {
      "normal": "Standard",
      "advanced": "Avanzata"
    },
    "advanced": {
      "notice": "La versione avanzata modifica esclusivamente il PDF che riceverai via email: confronta tre scenari (Scenario 1, 2 e 3) di prezzo GO ed energia. I risultati mostrati a schermo si riferiscono allo Scenario 1."
    }
  },
  "stepper": ["Seleziona impianto", "Inserisci dati", "Risultato"],
  "result": {
    "inputs-title": "I tuoi dati",
    "metrics-title": "Risultati chiave",
    "inputs": {
      "renewableEnergy": "Volume contrattualizzato",
      "goPrice": "Prezzo delle GO",
      "grayPrice": "Prezzo energia (materia prima)"
    },
    "metrics": {
      "profits": "Profitti + GO",
      "savings": "Risparmio sui costi energetici",
      "irr": "IRR dopo le imposte"
    },
    "irr-note": "* L'IRR è mostrato dopo le imposte perché trattenute alla fonte dal produttore. Il rendimento equivalente lordo ammonterebbe a {{value}} IRR.",
    "detail": {
      "unlock": {
        "title": "Risultati completi",
        "body": "Gratis: la simulazione anno per anno e il PDF dei risultati.",
        "cta": "Ottieni i risultati completi",
        "loading": "Sblocco dei risultati completi…"
      },
      "resend": {
        "label": "Vorresti ricevere un PDF con i risultati di questa simulazione?",
        "cta": "Invia di nuovo il PDF"
      },
      "popup": {
        "title": "Accedi ai tuoi risultati dettagliati",
        "description": "Inserisci la tua email nel box qui sotto per accedere alla simulazione anno per anno e ricevere il PDF che abbiamo preparato per te!",
        "placeholder": "nome@azienda.com",
        "confirm": "Invia il PDF",
        "sending": "Invio in corso…",
        "emailError": "Inserisci una email valida",
        "error": "Si è verificato un errore. Riprova.",
        "sentTitle": "PDF inviato con successo!",
        "sentDescription": "Controlla la tua casella di posta: il PDF con i risultati dettagliati è stato inviato al tuo indirizzo email. I risultati dettagliati sono ora accessibili anche da questa pagina.",
        "sentButton": "Chiudi"
      },
      "booking": {
        "title": "Prenota una chiamata",
        "description": "I nostri esperti ti forniranno maggiori dettagli sulla nostra soluzione.",
        "cta": "Prenota ora"
      },
      "chart": {
        "title": "Paragone dei costi dell'elettricità in {{currency}}",
        "red": "Costo elettricità rinnovabile acquistando GO",
        "green": "Costo elettricità rinnovabile producendo GO w/DEC"
      },
      "table": {
        "title": "Riepilogo economico",
        "initialInvestment": "Investimento iniziale (anno 0)",
        "profitSold": "Profitti (dopo le imposte) dalla vendita di energia (anno 1-{n})",
        "totalNet": "Netto totale (dopo le imposte, anno 1-{n})",
        "savings": "Risparmi totali producendo GO (anno 1-{n})",
        "total": "Netto totale (dopo le imposte) + risparmi totali",
        "irr": "IRR Equity",
        "irrNote": "L'IRR è mostrato dopo le imposte perché trattenute alla fonte dal produttore. Il rendimento equivalente lordo ammonterebbe a {{value}} IRR.",
        "breakEven": "Cash flow Break-even",
        "breakEvenNote": "Il break-even è mostrato dopo le imposte perché trattenute alla fonte dal produttore. Il break-even equivalente lordo sarebbe {{value}}.",
        "na": "N/D"
      },
      "yearTable": {
        "title": "Dettaglio annuale",
        "year": "Affittare pannelli fotovoltaici w/ DEC (in {{currency}})",
        "start": "Iniziale",
        "initialInvestment": "Investimento iniziale",
        "profits": "Profitti annuali (dopo le imposte) dall'energia venduta",
        "energyPrice": "al prezzo di vendita annuale di ({{currency}}/MWh):",
        "savings": "risparmi annuali dalle GO prodotte",
        "total": "Totale profitti (dopo le imposte) + risparmi"
      },
      "vp": {
        "title": "Esplora i benefici",
        "labels": {
          "riduzione-prevedibile": "Riduzione dei costi",
          "ebitda": "Incremento EBITDA",
          "conformita": "Conformità SBTi",
          "copertura-naturale": "Copertura naturale",
          "impatto": "Impatto raccontabile"
        },
        "riduzione": {
          "title": "Il costo netto dell'energia con DEC",
          "total": "Costi complessivi",
          "goValue": "Controvalore GO",
          "revenueShare": "Quota ricavi energia",
          "net": "Costo netto",
          "goCost": "Costo GO",
          "energyCost": "Costo energia",
          "disclaimer": "Costi di energia e GO stimati sull'orizzonte del contratto; proporzioni indicative."
        },
        "ebitda": {
          "title": "L'incremento di EBITDA con DEC",
          "baseline": "EBITDA attuale",
          "baselineNote": "illustrativo",
          "goSaving": "Risparmio GO",
          "energyRevenue": "Ricavi energia",
          "result": "EBITDA con DEC Energy",
          "disclaimer": "EBITDA attuale illustrativo; l'incremento riflette i valori calcolati. Il risparmio GO potrebbe non essere in scala. Secondo i principi contabili internazionali IAS/IFRS, l'operazione DEC Energy incrementa l'EBITDA."
        },
        "conformita": {
          "title": "Il costo della GO conforme SBTi",
          "yAxis": "Prezzo GO conforme SBTi",
          "time": "TEMPO",
          "market": "GO senza DEC Energy",
          "marketNote": "ipotetico, non in scala",
          "zero": "costo GO azzerato",
          "dec": "GO con DEC Energy"
        },
        "copertura": {
          "title": "Spesa contro ricavi, anno per anno",
          "spend": "Spesa energia",
          "revenue": "Ricavi impianti",
          "net": "Costo netto",
          "year": "Anno",
          "correlation": "La correlazione ipotizzata tra il delta del prezzo di acquisto dell'energia a mercato e quello di vendita dell'energia dell'impianto è del {{pct}}%",
          "disclaimer": "Grafico illustrativo; i ricavi DEC seguono il prezzo e appiattiscono il costo netto."
        },
        "impatto": {
          "title": "Impatto raccontabile",
          "type": "Agrivoltaico",
          "co2": "CO₂ evitata",
          "co2Note": "stima (0.4 t/MWh)",
          "crops": "Raccolto protetto",
          "cropsValue": "grandine e calore",
          "water": "Acqua risparmiata",
          "waterUnit": "m³/anno",
          "yield": "Resa agricola",
          "yieldValue": "+ 20%"
        }
      }
    },
    "restart": "Seleziona un altro impianto",
    "switch": "Prova un altro impianto",
    "switchNote": "il PDF non viene inviato di nuovo automaticamente",
    "select": "Seleziona",
    "backToInputs": "Modifica i dati"
  },
  "year": "anno"
}
